
import * as React from 'react';
import { BookemZulu } from 'src/core/services/data/JayDataContext';
import { CollapseCard } from 'src/app/shared/collapse-card.view';
import { Link } from 'react-router-dom';
import { DataLocalService } from 'src/core/services/data-local.service';
import { DataTableView, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { Divider } from 'antd';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { FormatService } from 'src/core/services/format.service';
import { resolve } from 'inversify-react';
import * as moment from 'moment';

interface IGroupPaxsViewProps {
	quotes: { [quoteNumber: string]: QuotePaxItem[] };
	setBusy: (isBusy: boolean) => void;
}

interface IGroupPaxsViewState {

}

@observer
export default class GroupPaxsView extends React.Component<IGroupPaxsViewProps, IGroupPaxsViewState>{

	render() {

		const keys = Object.getOwnPropertyNames(this.props.quotes);
		
		
		return keys.map(item => {
			const element = this.props.quotes[item][0];
			console.log(this.props.quotes[item].length);

			if (!element)
				return null;

			return (
				<div key={item}>
					<Link to={`/bookings/quotes/${element.quoteId}`}>{item}</Link>
					<Divider/>
					<QuotePaxTable
						paxs={this.props.quotes[item]}
						setBusy={this.props.setBusy}
					/>
				</div>)
		});
	}
}


interface IQuotePaxTableProps {
	paxs: QuotePaxItem[];
	setBusy: (isBusy: boolean) => void;
}

interface IQuotePaxTableState {

}

@observer
export class QuotePaxTable extends React.Component<IQuotePaxTableProps, IQuotePaxTableState>{

	@observable
	dataService: DataSet<QuotePaxItem>;

	@resolve
	formatService: FormatService;

	componentDidMount() {
		this.dataService = new DataLocalService(this.props.paxs, 50);
	}

	render() {

		if (!this.dataService || !this.dataService.item)
			return null;

		const columns = [
			{
				key: 'name',
				dataIndex: '',
				title: 'Name',
				render: (text, record: QuotePaxItem) => {


					return <p>{record.dynamicProperties['salutation']} {record.dynamicProperties['foreName']} {record.dynamicProperties['midlleName']} {record.dynamicProperties['surName']}</p>
				}
			},
			{
				key: 'nationality',
				dataIndex: 'dynamicProperties.nationality',
				title: 'Nationality'
			},
			{
				key: 'birthDate',
				dataIndex: '',
				title: 'Birth date',
				render: (text, record: QuotePaxItem) => {
					return this.formatService.toString("date", record.dynamicProperties["birthDate"]);
				}
			},
			{
				key: 'age',
				dataIndex: '',
				title: 'Age',
				render: (text, record: QuotePaxItem) => {

					const date = moment(record.dynamicProperties["birthDate"])

					return moment(moment.now()).diff(date, 'y');
				}
			},
			{
				key: 'gender',
				dataIndex: '',
				title: 'Gender',
				render: (text, record: QuotePaxItem) => {
					return record.dynamicProperties["gender"];
				}
			}


		];

		const visibility = ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hideSearch;


		return <DataTableView
			mode={'display'}
			rowKey='id'
			setBusy={this.props.setBusy}
			columns={columns}
			model={this.dataService}
			hideToolbar={visibility}
			selection={false}
		/>;
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/form/parts/paxs.view.tsx